import request from '../request';

/** 上传 */
export async function getUpload(params: any) {
  return request<API.CommonResponse<API.FileUploadResultVO>>({
    url: '/api/disp/mall/rest/file/user/uploadFile',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    data: params,
  });
}
